<template>
    <div class="steps-wrap">
        <div class="line"></div>
        <div class="steps">
            <div class="step" v-for="(item, index) in stepsData" :key="index" :class="{'active': item.step === curStep, 'done': item.status === 'done'}">
                <div class="step-text">{{ item.title }}</div>
                <div class="step-icon"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Step',
        props: {
            stepsData: Array,
            curStep: Number,
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .steps-wrap {
        width: 1230px;
        height: 122px;
        position: relative;
        margin: 0 auto 59px;
    }
    .line {
        width: 1230px;
        height: 22px;
        position: absolute;
        bottom: 0;
        background: #370e85;
    }
    .steps {
        width: 1230px;
        display: flex;
        justify-content: space-between;
    }
    .step {
        position: relative;
        height: 122px;
        .step-text {
            width: 172px;
            height: 58px;
            line-height: 46px;
            border: 6px solid #3e00c4;
            font-size: 12px;
            font-weight: bold;
            text-align: center;
            color: #fff;
            background: url('../assets/images/step-bg.png');
        }
        .step-icon {
            width: 41px;
            height: 37px;
            position: absolute;
            left: 50%;
            margin-left: -20px;
            bottom: 0;
            background: url('../assets/images/step-arr.png');
        }
        &.active {
            .step-text {
                transform: scale(1.2);
                border: 6px solid #0066ff;
                background: url('../assets/images/step-bg-cur.png');
            }
            .step-icon {
                background: url('../assets/images/step-arr-cur.png');
            }
        }
        &.done {
            .step-icon {
                background: url('../assets/images/step-arr-done.png');
            }
        }
    }
</style>
